import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { SeoService } from '@core/services/seo.service';
import { KnowledgeArticle, KnowledgeDestination } from '@generated/graphql';
import { BreadcrumbList, WithContext } from 'schema-dts';

import { JsonLdComponent } from '@features/seo/json-ld/json-ld.component';
import { LinkComponent } from '../../../shared/link/link.component';

@Component({
    selector: 'app-knowledge-article-breadcrumbs',
    templateUrl: './knowledge-article-breadcrumbs.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LinkComponent, JsonLdComponent],
})
export class KnowledgeArticleBreadcrumbsComponent implements OnInit {
    @Input() article: KnowledgeArticle;
    @Input() destination: KnowledgeDestination;

    seoBreadCrumbs: WithContext<BreadcrumbList>;

    constructor(
        private seoService: SeoService,
        private environmentService: EnvironmentService
    ) {}

    ngOnInit(): void {
        this.seoBreadCrumbs = this.seoService.generateBreadCrumbs([
            {
                name: 'Knowledge',
                url: `${this.environmentService.hostName()}/knowledge`,
            },
            {
                name: this.destination?.name,
                url: `${this.environmentService.hostName()}/knowledge/category/${
                    this.destination?.urlSlug
                }`,
            },
            {
                name: this.article?.title,
                url: `${this.environmentService.hostName()}/knowledge/${
                    this.article?.urlSlug
                }`,
            },
        ]);
    }
}
